/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Membership_Friend_Guest_TitleInputs */

const fr_membership_friend_guest_title = /** @type {(inputs: Membership_Friend_Guest_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inviter un ami`)
};

/**

* @param {Membership_Friend_Guest_TitleInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const membership_friend_guest_title = /** @type {((inputs?: Membership_Friend_Guest_TitleInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Membership_Friend_Guest_TitleInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_membership_friend_guest_title(inputs)
});